import { connect } from 'react-redux';
import FilePropertiesPanel from './FilePropertiesPanel';

const mapStateToProps = state => ({
  fileExtension: state.files.fileExtension
});

export default connect(mapStateToProps)(FilePropertiesPanel);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/filePropertiesPanel/FilePropertiesPanelConnector.js